import type { DockItemConfig } from './dockConfig'

interface Props {
  item: DockItemConfig
  active: boolean
  onClick: () => void
}

export default function DockItem({ item, active, onClick }: Props) {
  const Icon = item.icon

  return (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '3px' }}>
      <button
        onClick={onClick}
        title={item.label}
        style={{
          width: '46px',
          height: '46px',
          borderRadius: '12px',
          background: active
            ? `${item.color}25`
            : `linear-gradient(135deg, ${item.color}cc, ${item.color}88)`,
          border: active ? `1.5px solid ${item.color}` : 'none',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          cursor: 'pointer',
          transition: 'transform 0.15s, box-shadow 0.15s',
          boxShadow: active ? `0 0 12px ${item.color}40` : 'none',
        }}
        onMouseEnter={e => { e.currentTarget.style.transform = 'scale(1.15)' }}
        onMouseLeave={e => { e.currentTarget.style.transform = 'scale(1)' }}
      >
        <Icon size={20} color="#fff" />
      </button>
      {/* Active dot */}
      <div style={{
        width: '4px',
        height: '4px',
        borderRadius: '50%',
        background: active ? item.color : 'transparent',
        transition: 'background 0.15s',
      }} />
    </div>
  )
}
